export const authGuard = meta => {
  if (!meta?.consultant) {
    const redirectTo = meta?.pathname
      ? `?redirectTo=${encodeURIComponent(meta.pathname + (meta.search ?? ''))}`
      : ''
    return `/login${redirectTo}`
  }
  return null
}
